// src/services/toxicologistSearchAPI.js

// 1) Set your production API base (App Service) WITH protocol.
const PROD_API_BASE =
  process.env.REACT_APP_TOXIC_API_BASE ||
  'https://sot-express-to-azure-linux-gucvfsdncjajehf7.eastus-01.azurewebsites.net';

// const PROD_API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://<your-appservice>.azurewebsites.net';

//
const API_BASE = process.env.NODE_ENV === 'production' ? PROD_API_BASE : '';
//const API_BASE =
 // process.env.NODE_ENV === 'production'
  //  ? 'https:sot-express-to-azure-linux-gucvfsdncjajehf7.eastus-01.azurewebsites.net'
  //  : ''; // React dev uses CRA proxy
// quick debug (temporary)
console.log("API_BASE ->", JSON.stringify(API_BASE));

// Small helper to safely join base + path
function joinURL(base, path) {
  const b = (base || '').replace(/\/+$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${b}${p}`;
}

// One place for fetch logic
async function request(path, { method = 'POST', body, headers } = {}) {
  const url = joinURL(API_BASE, path);
  console.log('fetch →', method, url);

  const res = await fetch(url, {
    method,
    headers: { 'Content-Type': 'application/json', ...(headers || {}) },
    body: body ? JSON.stringify(body) : undefined,
    mode: 'cors',
    credentials: 'omit'
  });

  const text = await res.text().catch(() => '');
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { /* keep raw text in error below */ }

  if (!res.ok) {
    const msg = (data && (data.error || data.message)) || text || res.statusText;
    throw new Error(`Request failed ${res.status}: ${msg}`);
  }
  return data;
}

// Callers pass ONLY the path; do not include API_BASE again.
export function searchAbstracts(payload) {
  return request('/api/search', { method: 'POST', body: payload });
}